import { toast } from "react-toastify";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { _AbstractAccount, _TrainingRequest } from "../../../../../core/services/dataBean/EntityCatalog";
import { useEffect, useState } from "react";
import useModal, { MODAL_XL } from "../../../../theme/Component/hooks/useModal";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { BasicPage } from "../../../../theme/Component/BasicPage";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { Modal } from "../../../../theme/Component/Modal";
import { HandlerInfoProcess } from "../../../../bpm/config/InfoTramiteComponents/HandlerInfoProcess";
import usePaginator from "../../../../theme/Component/usePaginator";


export const TrainingRequest = () => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_TrainingRequest);
    const account = useDataBean(_AbstractAccount);
    const paginador = usePaginator();

    const modalHistory = useModal("Historial del procedimiento", MODAL_XL)
    const modalUsers = useModal("Usuarios capacitados", MODAL_XL)

    const [accountList, setAccountList] = useState<any[]>([]);

    useEffect(() => {
        getLista();
    }, [])

    const getIDAccountValue = (value: any) => {
        return Number(typeof value === "object" ? value?.IDAccount : value);
    }

    const getListIDAccounts = (value: any): number[] => {
        const normalizeIDs = (list: any[]) => {
            return list
                .map(getIDAccountValue)
                .filter((id) => !Number.isNaN(id));
        }

        if (!value) return [];
        if (Array.isArray(value)) return normalizeIDs(value);

        if (typeof value === "string") {
            const cleanValue = value.trim();
            if (!cleanValue) return [];

            try {
                const parsedValue = JSON.parse(cleanValue);
                return Array.isArray(parsedValue) ? normalizeIDs(parsedValue) : [];
            } catch {
                return normalizeIDs(cleanValue.split(",").map((id) => id.trim()));
            }
        }

        return [];
    }

    const getAccountName = (item: any) => {
        const data = item?.DataBeanProperties ?? item;
        const fullName = [
            data?.Name1,
            data?.Name2,
            data?.Surname1,
            data?.Surname2
        ].filter(Boolean).join(" ");

        return fullName
            || data?.AccountFullName
            || data?.EntityName
            || data?.FullName
            || data?.Name
            || data?.EmployeeFullName
            || data?.IDAccount
            || "N/A";
    }

    const openAccountList = (value: any) => {
        if (typeof value !== "string" || !value.includes("data-list-id-accounts")) return;

        const match = value.match(/data-list-id-accounts="([^"]*)"/);
        const idsAccount = match ? getListIDAccounts(decodeURIComponent(match[1])) : [];

        if (!idsAccount.length) {
            toast.warning("No hay usuarios para mostrar");
            return;
        }

        account.instance.getAccountsInfoByIds(idsAccount).then((resp: any) => {
            const accounts = resp?.DataBeanProperties?.ObjectValue ?? resp;
            if (Array.isArray(accounts)) {
                accounts.forEach((item: any) => {
                    const data = item?.DataBeanProperties ?? item;
                    data.AccountFullName = getAccountName(data);
                    data.Nit = data.nit ?? data.Nit;
                    data.Email = data.eMail ?? data.Email;
                });
            }
            setAccountList(Array.isArray(accounts) ? accounts : []);
            modalUsers.open();
        }).catch(() => {
            toast.error("No se pudo cargar la informacion de los usuarios");
        });
    }

    const getLista = () => {
        const props = {

        }

        instance.getTrainingRequestRender(paginador.page, 15, props).then(
            (resp: any) => {
                paginador.setPages(resp.NumberOfPages);
                paginador.setRecords(resp.NumberOfPages * 15);

                resp.List.forEach(element => {
                    const data = element.DataBeanProperties ?? element;
                    const targetScopeType = Number(data.TargetScopeType);

                    data.TargetScopeTypeRender = data.TargetScopeTypeName ?? "N/A";

                    if (targetScopeType === 101) {
                        data.TargetScopeTypeRender = data.AreaName ?? data.IDLnFunctionalIDName ?? data.FunctionalIDName ?? data.IDLnFunctionalID ?? "N/A";
                    }

                    if (targetScopeType === 102) {
                        const idsAccount = getListIDAccounts(data.ListIDAccounts);
                        data.TargetScopeTypeRender = idsAccount.length
                            ? `<a class="text-primary text-decoration-underline pointer" data-list-id-accounts="${encodeURIComponent(JSON.stringify(idsAccount))}">ver usuarios</a>`
                            : "N/A";
                    }

                    if (targetScopeType === 103) {
                        data.TargetScopeTypeRender = data.AccountFullName ?? data.EntityName ?? data.IDAccount ?? "N/A";
                    }
                });

                setLista(resp.List);
            }
        ).catch(err => {
            toast.error("Error al cargar la lista de Solicitudes");
        });
    };

    const head = [
        { title: 'ID', property: 'IDTrainingRequest', visible: true },
        { title: 'Codigo solicitud', property: 'ProcedureAlphaCode', visible: true },
        { title: 'Descripcion', property: 'Description', visible: true },
        { title: 'Justificacion', property: 'Justification', visible: true },
        { title: 'Solicitante', property: 'EmployeeFullName', visible: true },

        { title: 'Alcance de la Capacitación', property: 'TargetScopeTypeName', visible: true },
        { title: 'Capacitados', property: 'TargetScopeTypeRender', visible: true },

        { title: 'Estado', property: 'StateName', visible: true },

        { title: 'Fecha de Solicitud', property: 'Since', visible: true },
    ];

    const headUsers = [
        { title: 'ID', property: 'IDAccount', visible: true },
        { title: 'Documento', property: 'Nit', visible: true },
        { title: 'Nombre', property: 'AccountFullName', visible: true },
        { title: 'Correo', property: 'Email', visible: true },
    ];


    const listaBotones = () => {
        const botones = [
            { titulo: 'Historico', icono: 'ri-edit-2-line', visible: bean.IDProcedureIMP, evento: () => { modalHistory.open() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    return (
        <BasicPage titulo="Lista de Solicitudes Capacitacion">
            <div className="row">
                <div className="col-md-12">
                    <BasicTable listButtons={listaBotones()} body={lista} head={head} rowSet={setBean} _returnCellValue={openAccountList} />

                    <Modal modal={modalHistory.modal} updateModal={modalHistory.setModal} >
                        <HandlerInfoProcess _ProcedureIMPID={bean.IDProcedureIMP} />
                    </Modal>

                    <Modal modal={modalUsers.modal} updateModal={modalUsers.setModal} >
                        <BasicTable body={accountList} head={headUsers} rowSet={() => { }} customRows={15} />
                    </Modal>
                </div>
            </div>
        </BasicPage>
    )
}
